import has from 'lodash/has.js';

export default {
    state: {
        breadcrumbs: [],
    },

    getters: {
        home: () => ({
            text: 'Home',
            to: { name: 'home' },
        }),

        courses: () => ({
            text: 'Courses',
            to: { name: 'courses' },
        }),

        courseTemplates: () => ({
            text: 'Course Templates',
            to: { name: 'course-templates' },
        }),

        quizzes: () => ({
            text: 'Quizzes',
            to: { name: 'quizzes-index' },
        }),

        people: () => ({
            text: 'People',
            to: { name: 'people-index' },
            ability: { action: 'view', subject: 'users page' },
        }),

        myProfile: () => ({
            text: 'My Profile',
            to: { name: 'people-index' },
            ability: { action: 'view', subject: 'users page' },
        }),

        groups: () => ({
            text: 'Groups',
            to: { name: 'groups-index' },
        }),

        meetings: () => ({
            text: 'Meetings',
            to: { name: 'course-meetings-view' },
        }),

        meetingsIndex: () => ({
            text: 'Meetings',
            to: { name: 'meetings-index' },
        }),

        attemptAuthorizationsIndex: () => ({
            text: 'Attempt Authorizations',
            to: { name: 'attempt-authorizations-index' },
        }),

        attendance: () => ({
            text: 'Attendance',
            to: { name: 'course-attendance' },
        }),

        attemptAuthorizations: () => ({
            text: 'Attempt Authorizations',
            to: { name: 'course-attempt-authorizations-view' },
        }),

        quizDashboard: () => ({
            text: 'Quiz Dashboard',
            to: { name: 'quiz-dashboard' },
        }),

        locations: () => ({
            text: 'Locations',
            to: { name: 'locations-index' },
        }),

        reports: () => ({
            text: 'Reports',
            to: { name: 'reports-index' },
        }),

        integrations: () => ({
            text: 'Integrations',
            to: { name: 'integrations-index' },
        }),
    },

    actions: {
        addDefault({ commit, getters }, breadcrumbName) {
            commit('PUSH', getters[breadcrumbName]);
        },

        pushBreadcrumb({ commit, getters }, breadcrumb) {
            if (Array.isArray(breadcrumb)) {
                breadcrumb.forEach(crumb => commit('PUSH', crumb));
            } else if (typeof breadcrumb === 'string') {
                if (!has(getters, breadcrumb)) {
                    throw new Error(
                        `The breadcrumb specified does not exist as a default. Perhaps you meant \`{ text: '${breadcrumb}' }\``
                    );
                }

                commit('PUSH', getters[breadcrumb]);
            } else {
                commit('PUSH', breadcrumb);
            }
        },
    },

    mutations: {
        SET(state, breadcrumbs) {
            state.breadcrumbs = breadcrumbs;
        },

        PUSH(state, breadcrumb) {
            state.breadcrumbs.push(breadcrumb);
        },

        POP(state) {
            state.breadcrumbs.pop();
        },

        REPLACE(state, payload) {
            const index = state.breadcrumbs.findIndex(breadcrumb => {
                return breadcrumb.text === payload.find;
            });

            if (index) {
                state.breadcrumbs.splice(index, 1, payload.replace);
            }
        },

        EMPTY(state) {
            state.breadcrumbs = [];
        },
    },
};
